import React from 'react';
import {
  TrackingProvider as Provider,
  createEventTracker,
  configureTracking,
  TrackingMiddleware,
} from '@zapier/toolbox-tracking';
import { EventName } from './events';

const httpRefererKey = 'http_referer_blog';

configureTracking({
  service: 'nextjs_ssg',
  release: 'git-sha-unavailable',
});

type Props = {
  children: React.ReactNode;
};

const addHttpRefererToNavigateEvent: TrackingMiddleware = () => async (
  event,
) => {
  if ((event.name as EventName) === 'navigate_blog') {
    /**
     * We need this because Next.js uses client-side routing, and that causes `document.referrer` to be empty
     * whenever a route changes.
     *
     * This issue is not Next.js specific, it's a Single Page Application issue.
     */
    event.apply({
      http_referer: localStorage.getItem(httpRefererKey) || document.referrer,
    });
  }
};

const setHttpRefererInLocalStorage: TrackingMiddleware = () => async (
  event,
) => {
  if ((event.name as EventName) === 'categoryClicked') {
    setHttpRefererFromStorage();
  }
};

export const TrackingProvider = ({ children }: Props) => {
  const trackingFunctions = createEventTracker([
    setHttpRefererInLocalStorage,
    addHttpRefererToNavigateEvent,
  ]);

  return <Provider trackingFunctions={trackingFunctions}>{children}</Provider>;
};

export const cleanHttpRefererFromStorage = () =>
  localStorage.removeItem(httpRefererKey);
export const setHttpRefererFromStorage = () =>
  localStorage.setItem(httpRefererKey, location.href);
